import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "grid gap-3" }

import { InputRow, Combobox } from '@/components/ui/form';
    import { Input } from '@/components/ui/input';
    // import { computed } from 'vue';
    // import type { SelectOption } from '@/types';
    // import { useI18n } from 'vue-i18n';
    import { Checkbox } from '@/components/ui/checkbox';
    import { Label } from '@/components/ui/label';
    import { Alert } from '@/components/ui/alert';

    // const { tm } = useI18n();

    // const countryOptions = computed<SelectOption[]>(() => {
    //     const map = tm('employee.address.country_codes_array') as Record<string, string>;
    //     return Object.entries(map).map(([value, label]) => ({ value, label }));
    // });

    
export default /*@__PURE__*/_defineComponent({
  __name: 'EmployeeBankForm',
  props: {
    form: {}
  },
  setup(__props: any) {

    

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(Label), {
      for: "use_iban",
      class: "flex cursor-pointer items-center"
    }, {
      default: _withCtx(() => [
        _createVNode(_unref(Checkbox), {
          modelValue: _ctx.form.bank.use_iban,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.form.bank.use_iban) = $event)),
          id: "use_iban"
        }, null, 8, ["modelValue"]),
        _createElementVNode("span", null, _toDisplayString(_ctx.$t('employee.bank.non_danish_account')), 1)
      ]),
      _: 1
    }),
    (_ctx.form.bank.use_iban)
      ? (_openBlock(), _createBlock(_unref(Alert), {
          key: 0,
          variant: "warning"
        }, {
          default: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('employee.bank.transfer_manually')), 1)
          ]),
          _: 1
        }))
      : _createCommentVNode("", true),
    (!_ctx.form.bank.use_iban)
      ? (_openBlock(), _createBlock(_unref(InputRow), {
          key: 1,
          form: _ctx.form,
          name: "bank_reg",
          label: "employee.bank.bank_reg",
          "error-key": "bank.bank_reg"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Input), {
              id: "bank_reg",
              modelValue: _ctx.form.bank.bank_reg,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.form.bank.bank_reg) = $event)),
              placeholder: _ctx.$t('employee.bank.bank_reg')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true),
    (!_ctx.form.bank.use_iban)
      ? (_openBlock(), _createBlock(_unref(InputRow), {
          key: 2,
          form: _ctx.form,
          name: "bank_account",
          label: "employee.bank.bank_account",
          "error-key": "bank.bank_account"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Input), {
              id: "bank_account",
              modelValue: _ctx.form.bank.bank_account,
              "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.form.bank.bank_account) = $event)),
              placeholder: _ctx.$t('employee.bank.bank_account')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true),
    (_ctx.form.bank.use_iban)
      ? (_openBlock(), _createBlock(_unref(InputRow), {
          key: 3,
          form: _ctx.form,
          name: "iban",
          label: "employee.bank.iban",
          "error-key": "bank.iban"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Input), {
              id: "iban",
              modelValue: _ctx.form.bank.iban,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_ctx.form.bank.iban) = $event)),
              placeholder: _ctx.$t('employee.bank.iban')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true),
    (_ctx.form.bank.use_iban)
      ? (_openBlock(), _createBlock(_unref(InputRow), {
          key: 4,
          form: _ctx.form,
          name: "swift",
          label: "employee.bank.swift",
          "error-key": "bank.swift"
        }, {
          default: _withCtx(() => [
            _createVNode(_unref(Input), {
              id: "swift",
              modelValue: _ctx.form.bank.swift,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.form.bank.swift) = $event)),
              placeholder: _ctx.$t('employee.bank.swift')
            }, null, 8, ["modelValue", "placeholder"])
          ]),
          _: 1
        }, 8, ["form"]))
      : _createCommentVNode("", true)
  ]))
}
}

})